// src/components/shared/useMobilAnsichtErzwingen.js
// Globale, manuelle Übersteuerung "Mobil-Ansicht erzwingen" - unabhängig von der über
// useIsDesktop() erkannten Bildschirmbreite. Grund: Tablets (v.a. im Hochformat) haben oft
// trotzdem ≥701px Breite und werden über die reine Breakpoint-Erkennung als Desktop eingestuft -
// das Nebeneinander-Layout lässt sich auf einem Tablet im Hochformat aber kaum bedienen. Da es
// keine 100% zuverlässige, auflösungsunabhängige "ist es ein Mobilgerät"-Erkennung gibt, kann der
// Nutzer selbst umschalten (Header, siehe Toggle dort).
//
// Wert wird in localStorage gemerkt (pro Gerät/Browser) UND über ein modulweites Mini-Pub/Sub
// synchron zwischen allen Stellen gehalten, die den Hook nutzen (Header zum Umschalten, App.js
// für die CSS-Klasse auf .app-container, RechnungTab für kameraVerfuegbar) - ganz ohne React
// Context oder Prop-Drilling einführen zu müssen.
import { useSyncExternalStore } from 'react'

const STORAGE_KEY = 'datenleser.mobilAnsichtErzwingen'

function liesGespeichertenWert () {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === 'true'
  } catch {
    return false
  }
}

let aktuellerWert = liesGespeichertenWert()
const subscribers = new Set()

function setzeWert (wert) {
  aktuellerWert = wert
  try {
    window.localStorage.setItem(STORAGE_KEY, wert ? 'true' : 'false')
  } catch {
    // localStorage evtl. nicht verfügbar (z.B. Privatmodus) - Wert gilt dann nur für diese Sitzung.
  }
  subscribers.forEach(callback => callback())
}

function subscribe (callback) {
  subscribers.add(callback)
  return () => subscribers.delete(callback)
}

function getSnapshot () {
  return aktuellerWert
}

export function useMobilAnsichtErzwingen () {
  const mobilAnsichtErzwingen = useSyncExternalStore(subscribe, getSnapshot)
  return [mobilAnsichtErzwingen, setzeWert]
}

export default useMobilAnsichtErzwingen